<template>
    <!-- Header -->
    <header
        class="tw:fixed tw:left-4 tw:right-4 tw:h-15 tw:z-999 tw:rounded-2xl tw:border tw:transition-all tw:duration-300 tw:flex tw:items-center tw:justify-between tw:gap-2 tw:sm:gap-3 tw:px-2 tw:sm:px-4"
        :class="[sidebarCollapsed ? 'tw:lg:left-24' : 'tw:lg:left-74', scrolled ? 'tw:top-0 tw:bg-brand-primary tw:border-transparent tw:shadow-lg' : 'tw:top-4 tw:bg-white tw:border-gray-200 tw:shadow-sm']">
        <div class="tw:flex tw:items-center tw:gap-3">
            <button type="button" @click="toggleSidebar" aria-label="Colapsar menú"
                class="tw:hidden tw:lg:inline-flex tw:items-center tw:justify-center tw:w-9 tw:h-9 tw:rounded-lg tw:border-0 tw:bg-transparent tw:cursor-pointer tw:transition-colors"
                :class="scrolled ? 'tw:text-white tw:hover:bg-white/10' : 'tw:text-slate-500 tw:hover:bg-slate-100 tw:hover:text-slate-800'">
                <i class="fas fa-align-left tw:text-2xl"></i>
            </button>
            <button type="button" @click="toggleMobileSidebar" aria-label="Abrir menú"
                class="tw:lg:hidden tw:inline-flex tw:items-center tw:justify-center tw:w-10 tw:h-10 tw:rounded-lg tw:border-0 tw:bg-transparent tw:cursor-pointer tw:text-lg tw:transition-colors"
                :class="scrolled ? 'tw:text-white tw:hover:bg-white/10' : 'tw:text-slate-500 tw:hover:bg-slate-100 tw:hover:text-slate-800'">
                <i class="fas fa-bars tw:text-lg"></i>
            </button>
        </div>

        <ul class="tw:flex tw:items-center tw:gap-1.5 tw:sm:gap-3 tw:list-none tw:m-0 tw:p-0 tw:min-w-0">
            <!-- Currency Exchange -->
            <li class="tw:flex tw:items-center">
                <span id="currencyExchange"
                    class="tw:text-xs tw:font-medium tw:whitespace-nowrap tw:px-2.5 tw:py-1 tw:rounded-full tw:transition-colors"
                    :class="scrolled ? 'tw:bg-white/15 tw:text-white' : 'tw:bg-slate-100 tw:text-slate-700'">
                    USD ${{ configuration.usd }}
                </span>
            </li>

            <!-- Academia Button -->
            <li v-if="showAcademia" class="tw:hidden tw:sm:block">
                <a :href="getUrl('academia')" target="_blank"
                    class="tw:inline-flex tw:items-center tw:justify-center tw:px-3 tw:py-1.5 tw:text-xs tw:font-semibold tw:text-white tw:rounded-lg tw:shadow-sm tw:transition-opacity tw:hover:opacity-90 tw:no-underline"
                    :class="scrolled ? 'tw:bg-brand-background' : 'tw:bg-brand-primary'">
                    Academia
                </a>
            </li>

            <!-- Notifications -->
            <li class="tw:relative" v-click-outside="() => notiDropdownOpen = false">
                <button type="button"
                    class="tw:relative tw:inline-flex tw:items-center tw:justify-center tw:w-9 tw:h-9 tw:rounded-lg tw:border-0 tw:bg-transparent tw:cursor-pointer tw:transition-colors"
                    :class="scrolled ? 'tw:text-white tw:hover:bg-white/10' : 'tw:text-slate-500 tw:hover:bg-slate-100 tw:hover:text-slate-800'"
                    aria-label="Notificaciones" @click="notiDropdownOpen = !notiDropdownOpen">
                    <i class="far fa-bell tw:text-xl"></i>
                    <span v-if="totalNotification > 0"
                        class="tw:absolute tw:top-1 tw:right-1 tw:w-3 tw:h-3 tw:bg-red-500 tw:rounded-full tw:border-2 tw:border-white"></span>
                </button>
                <div class="tw:fixed tw:inset-x-2 tw:top-19 tw:sm:absolute tw:sm:inset-x-auto tw:sm:top-full tw:sm:right-0 tw:sm:mt-2 tw:sm:w-80 tw:bg-white tw:rounded-2xl tw:shadow-xl tw:border tw:border-slate-100 tw:py-2 tw:z-50 tw:overflow-hidden"
                    v-show="notiDropdownOpen">
                    <div
                        class="tw:flex tw:items-center tw:justify-between tw:px-4 tw:py-3 tw:border-b tw:border-slate-100">
                        <span class="tw:text-sm tw:font-semibold tw:text-slate-700">Notificaciones (
                            {{ totalNotification }} )</span>
                        <a v-if="totalNotification > 0"
                            class="tw:text-xs tw:text-brand-primary tw:cursor-pointer tw:font-medium tw:hover:underline"
                            @click="clearAllNotifications()"> Limpiar todo </a>
                    </div>
                    <div class="tw:max-h-[60dvh] tw:sm:max-h-80 tw:overflow-y-auto">
                        <ul class="tw:list-none tw:m-0 tw:p-0">
                            <li class="tw:border-b tw:border-slate-50 tw:last:border-0" v-for="item in notifications"
                                :key="'noti' + item.id" @click="getNotifications()">
                                <router-link :to="`${item.data.url}?notification=${item.id}`"
                                    class="tw:flex tw:items-start tw:gap-3 tw:px-4 tw:py-3 tw:no-underline tw:hover:bg-slate-50 tw:transition-colors">
                                    <span
                                        class="tw:shrink-0 tw:w-8 tw:h-8 tw:rounded-full tw:overflow-hidden tw:bg-slate-100">
                                        <img class="tw:w-full tw:h-full tw:object-cover tw:rounded-full" alt=""
                                            :src="item.data.icon">
                                    </span>
                                    <div class="tw:min-w-0">
                                        <p class="tw:text-xs tw:font-medium tw:text-slate-700 tw:m-0 tw:truncate">
                                            {{ item.data.title }}
                                        </p>
                                        <p class="tw:text-[11px] tw:text-slate-400 tw:m-0 tw:mt-0.5">
                                            <span> {{ item.data.date | date_format_time }} </span>
                                        </p>
                                    </div>
                                </router-link>
                            </li>
                        </ul>
                    </div>
                    <div class="tw:px-4 tw:py-2.5 tw:border-t tw:border-slate-100 tw:text-center">
                        <a class="tw:text-xs tw:text-brand-primary tw:cursor-pointer tw:font-medium tw:hover:underline"
                            @click="getNotifications()">Actualizar</a>
                    </div>
                </div>
            </li>
            <!-- /Notifications -->

            <!-- User Menu -->
            <li>
                <BaseDropdown>
                    <template #trigger="{ open, toggle }">
                        <button type="button" aria-haspopup="menu" :aria-expanded="open ? 'true' : 'false'"
                            class="tw:inline-flex tw:items-center tw:border-0 tw:bg-transparent tw:cursor-pointer tw:p-0"
                            @click="toggle">
                            <img class="tw:rounded-full tw:w-10 tw:h-10 tw:object-cover tw:border tw:border-slate-200"
                                :src="user?.image || '/images/no-image.png'" alt="Admin">
                        </button>
                    </template>

                    <BaseDropdownItem icon="fa fa-user" to="/admin/perfil">Mi perfil</BaseDropdownItem>
                    <BaseDropdownItem
                        v-if="ACCESS_MENU_ACTION(AGENCY_CONFIGURATIONS_INDEX) && configuration.agency_owner"
                        icon="fa fa-cog" to="/admin/configuracion">Configuración
                    </BaseDropdownItem>
                    <BaseDropdownItem v-if="showAcademia" icon="fas fa-graduation-cap" :href="getUrl('academia')"
                        target="_blank">
                        Academia
                    </BaseDropdownItem>
                    <BaseDropdownItem v-if="configuration.agency_owner" icon="fas fa-file-contract"
                        :href="getUrl('contratos')" target="_blank">
                        Contratos
                    </BaseDropdownItem>
                    <div class="tw:my-1 tw:border-t tw:border-slate-100"></div>
                    <BaseDropdownItem icon="fa fa-sign-out-alt" variant="danger" @click="logout()">
                        Cerrar sesión
                    </BaseDropdownItem>
                </BaseDropdown>
            </li>
            <!-- /User Menu -->
        </ul>
    </header>
    <!-- /Header -->
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import { ROUTE_LOGIN } from "@/enums/RouteNameEnums";
import { ACCESS_MENU_ACTION } from '@/validations/auth/AccessControlList'
import { AGENCY_CONFIGURATIONS_INDEX } from '@/enums/MenuActionEnums';
import { toggleSidebar, toggleMobileSidebar, isSidebarEffectivelyCollapsed } from '@/plugins/sidebarStore';
export default {
    name: 'TopBar',
    props: {
        // Set by TemplateDashboard.vue once its scroll container scrolls past the top.
        scrolled: { type: Boolean, default: false },
    },
    data() {
        return {
            notifications: [],
            totalNotification: 0,
            AGENCY_CONFIGURATIONS_INDEX,
            notiDropdownOpen: false,
            userDropdownOpen: false,
        }
    },
    computed: {
        ...mapGetters("auth", ["user"]),
        ...mapGetters("config", ["configuration"]),
        sidebarCollapsed() {
            return isSidebarEffectivelyCollapsed();
        },
        showAcademia() {
            return !(this.configuration.name || '').includes('Aliht');
        },
    },
    created() {
        this.getNotifications();

        window.Push.Permission.request();
        window.Echo.private(`App.Models.User.${localStorage.getItem("userNumber")}`)
            .notification((notification) => {
                if (notification.icon) {
                    window.Push.create(notification.title, {
                        body: notification.body,
                        link: notification.url,
                        icon: notification.icon,
                        onClick: function () {
                            window.location.href = notification.url;
                            this.close();
                        }
                    });
                }
                this.getNotifications();
            });
    },
    methods: {
        ACCESS_MENU_ACTION,
        ...mapActions("auth", ["sendLogoutRequest"]),
        logout() {
            this.sendLogoutRequest();
            setTimeout(() => {
                this.$router.push({ name: ROUTE_LOGIN });
            }, 1500);
        },
        getNotifications() {
            fetch(`${this.$baseUrl}/api/${this.$subdomain}/notifications`, {
                headers: {
                    'Authorization': `Bearer ${localStorage.getItem("authToken")}`
                },
            })
                .then(response => response.json())
                .then(data => {
                    this.notifications = data.data;
                    this.totalNotification = data.count;
                })
                .catch(error => {
                    console.error('Error en la fetch:', error);
                });
        },
        toggleSidebar,
        toggleMobileSidebar,
        clearAllNotifications() {
            this.$axios
                .post(`/${this.$subdomain}/notifications-clear-all`, {
                    '_method': 'PUT'
                })
                .then(response => {
                    this.getNotifications();
                })
                .catch((e) => {
                    this.$store.commit("setErrors", e);
                });
        },
        getUrl(service) {
            let token = localStorage.getItem("authToken");
            let hostname = location.hostname;
            let domain = hostname;
            let subdomain = "";

            if (hostname.includes(".")) {
                subdomain = hostname.split(".")[0];
                domain = hostname.split(".").slice(1).join(".");
            }

            return `http://www.${service}.${domain}?token=${token}&subdomain=${subdomain}`;
        }
    }
}
</script>